import { useState, useEffect } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import "../styles/blogs.css";
import { Navigation, Pagination } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";

export default function BlogPosts() {
  const [postsData, setpostsData] = useState([]);
  useEffect(() => {
    fetch(
      // 'https://swerkyblog.wordpress.com/feed',
      "https://vercel-funcs.vercel.app/api/cors-proxy/"
    )
      .then(async (response) => {
        let res = await response.json();
        // console.log(res);
        return res.body;
      })
      .then((str) => new window.DOMParser().parseFromString(str, "text/xml"))
      .then((data) => {
        // console.log(data);
        const items = data.querySelectorAll("item");
        let html = ``,
          dataArr = [];
        items.forEach((el) => {
          let imageUrl = el.querySelector("thumbnail").getAttribute("url"),
            title = el.querySelector("title").innerHTML,
            date = el.querySelector("pubDate").innerHTML,
            link = el.querySelector("link").innerHTML;

          dataArr.push({
            imageUrl,
            title,
            date,
            link,
            dateObject: new Date(date),
          });
        });
        dataArr.sort((a, b) => b.dateObject - a.dateObject);
        setpostsData(dataArr);
      })
      .catch((e) => console.log(e));
  }, []);
  const renderPosts = postsData?.map((post, index) => (
    <SwiperSlide key={index}>
      <PostCard {...post} />
    </SwiperSlide>
  ));

  return (
    <div>
      {postsData?.length > 0 && (
        <h1
          style={{
            margin: "auto",
            marginTop: "1rem",
            color: "white",
            width: "auto",
            textAlign: "center",
            padding: "5vh 0",
          }}
        >
          <a
            href="https://swerkyblog.wordpress.com/"
            target="_blank"
            style={{
              color: "white",
              marginInlineEnd: "5px",
            }}
          >
            Blog
          </a>
          Posts
        </h1>
      )}

      <div id="blog-posts" className="d-flex" onDrag={() => false}>
        {/* {postsData.map((post, k) => (
          <PostCard key={k} {...post} />
        ))} */}
        <Swiper
          className="services"
          // effect="fade"
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          allowTouchMove
          // centeredSlides
          centerInsufficientSlides
          slidesPerView="auto"
          spaceBetween={30}
          breakpoints={{
            // 1990: {
            //   slidesPerView: 5,
            // },
            1390: {
              slidesPerView: 4,
            },
            990: {
              slidesPerView: 3,
            },
            550: {
              slidesPerView: 2,
            },
            400: {
              slidesPerView: 1.5,
            },
            1: {
              slidesPerView: 1,
            },
          }}
          pagination={{
            dynamicBullets: true,
            clickable: true,
            type: "bullets",
            // el: ".categories-pagination-most-sold",
          }}
          //   navigation={{
          //     nextEl: `.swiper_button_next_most_sold`,
          //     prevEl: `.swiper_button_prev_most_sold`,
          //   }}
          modules={[Pagination]}
        >
          {renderPosts}
        </Swiper>
      </div>
    </div>
  );
}

function PostCard({ imageUrl, title, date, link }) {
  return (
    <a href={link} target="_blank">
      <Card>
        <CardBody>
          <CardTitle className="p-2  fw-bold">{title}</CardTitle>
          <img
            loading="lazy"
            src={imageUrl}
            alt=""
            style={{ width: "40vh", maxWidth: "100%", borderRadius: "1vh" }}
            onDrag={(e) => e.preventDefault()}
          />
          <small className="p-2">{date.split("+")[0] ?? ""}</small>
        </CardBody>
      </Card>
    </a>
  );
}
